import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '@/features/auth/hooks/useAuth';
import { routePaths } from '../routes';
import { FullScreenLoader } from '@/components/feedback/FullScreenLoader';

/**
 * Inverse of ProtectedRoute: keeps already-authenticated users out of the auth
 * screens (login/register), sending them to the app home instead.
 */
export function PublicOnlyRoute() {
  const { isAuthenticated, isInitialized } = useAuth();

  if (!isInitialized) return <FullScreenLoader />;
  if (isAuthenticated) return <Navigate to={routePaths.home} replace />;

  return <Outlet />;
}
